export enum MimeTypes {
  APPLICATION_EXCEL = "application/excel",
  APPLICATION_MSEXCEL = "application/msexcel",
  APPLICATION_MSWORD = "application/msword",
  APPLICATION_OCTET_STREAM = "application/octet-stream",
  APPLICATION_PDF = "application/pdf",
  APPLICATION_POWERPOINT = "application/powerpoint",
  APPLICATION_RAR = "application/rar",
  APPLICATION_S_COMPRESSED = "application/s-compressed",
  APPLICATION_VND_MS_EXCEL = "application/vnd.ms-excel",
  APPLICATION_VND_MS_OFFICE = "application/vnd.ms-office",
  APPLICATION_VND_MS_POWERPOINT = "application/vnd.ms-powerpoint",
  APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_PRESENTATION = "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_SHEET = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  APPLICATION_WBXML = "application/wbxml",
  APPLICATION_XLS = "application/xls",
  APPLICATION_XML = "application/xml",
  APPLICATION_XSPF_XML = "application/xspf+xml",
  APPLICATION_X_7Z_COMPRESSED = "application/x-7z-compressed",
  APPLICATION_X_BZIP = "application/x-bzip",
  APPLICATION_X_BZIP2 = "application/x-bzip2",
  APPLICATION_X_COMPRESS = "application/x-compress",
  APPLICATION_X_COMPRESSED = "application/x-compressed",
  APPLICATION_X_DOS_MS_EXCEL = "application/x-dos_ms_excel",
  APPLICATION_X_EXCEL = "application/x-excel",
  APPLICATION_X_GTAR = "application/x-gtar",
  APPLICATION_X_GZIP = "application/x-gzip",
  APPLICATION_X_MSEXCEL = "application/x-msexcel",
  APPLICATION_X_MS_EXCEL = "application/x-ms-excel",
  APPLICATION_X_PHOTOSHOP = "application/x-photoshop",
  APPLICATION_X_RAR = "application/x-rar",
  APPLICATION_X_RAR_COMPRESSED = "application/x-rar-compressed",
  APPLICATION_X_XLS = "application/x-xls",
  APPLICATION_X_ZIP = "application/x-zip",
  APPLICATION_X_ZIP_COMPRESSED = "application/x-zip-compressed",
  APPLICATION_ZIP = "application/zip",
  AUDIO_AC3 = "audio/ac3",
  AUDIO_AIFF = "audio/aiff",
  AUDIO_MIDI = "audio/midi",
  AUDIO_MP3 = "audio/mp3",
  AUDIO_MPEG = "audio/mpeg",
  AUDIO_MPEG3 = "audio/mpeg3",
  AUDIO_MPG = "audio/mpg",
  AUDIO_OGG = "audio/ogg",
  AUDIO_WAV = "audio/wav",
  AUDIO_WAVE = "audio/wave",
  AUDIO_X_ACC = "audio/x-acc",
  AUDIO_X_AIFF = "audio/x-aiff",
  AUDIO_X_AU = "audio/x-au",
  AUDIO_X_FLAC = "audio/x-flac",
  AUDIO_X_M4A = "audio/x-m4a",
  AUDIO_X_MS_WMA = "audio/x-ms-wma",
  AUDIO_X_PN_REALAUDIO = "audio/x-pn-realaudio",
  AUDIO_X_PN_REALAUDIO_PLUGIN = "audio/x-pn-realaudio-plugin",
  AUDIO_X_REALAUDIO = "audio/x-realaudio",
  AUDIO_X_WAV = "audio/x-wav",
  FONT_OTF = "font/otf",
  FONT_SFNT = "font/sfnt",
  FONT_TTF = "font/ttf",
  FONT_WOFF = "font/woff",
  FONT_WOFF2 = "font/woff2",
  IMAGE_BMP = "image/bmp",
  IMAGE_GIF = "image/gif",
  IMAGE_JP2 = "image/jp2",
  IMAGE_JPEG = "image/jpeg",
  IMAGE_JPM = "image/jpm",
  IMAGE_JPX = "image/jpx",
  IMAGE_MS_BMP = "image/ms-bmp",
  IMAGE_PJPEG = "image/pjpeg",
  IMAGE_PNG = "image/png",
  IMAGE_SVG_XML = "image/svg+xml",
  IMAGE_TIFF = "image/tiff",
  IMAGE_VND_ADOBE_PHOTOSHOP = "image/vnd.adobe.photoshop",
  IMAGE_VND_MICROSOFT_ICON = "image/vnd.microsoft.icon",
  IMAGE_WEBP = "image/webp",
  IMAGE_XMS_BMP = "image/x-ms-bmp",
  IMAGE_X_BITMAP = "image/x-bitmap",
  IMAGE_X_BMP = "image/x-bmp",
  IMAGE_X_ICO = "image/x-ico",
  IMAGE_X_ICON = "image/x-icon",
  IMAGE_X_PNG = "image/x-png",
  IMAGE_X_WINDOWS_BMP = "image/x-windows-bmp",
  IMAGE_X_WIN_BITMAP = "image/x-win-bitmap",
  IMAGE_X_XBITMAP = "image/x-xbitmap",
  MULTIPART_X_ZIP = "multipart/x-zip",
  TEXT_CALENDAR = "text/calendar",
  TEXT_COMMA_SEPARATED_VALUES = "text/comma-separated-values",
  TEXT_CSS = "text/css",
  TEXT_HTML = "text/html",
  TEXT_JSON = "text/json",
  TEXT_PHP = "text/php",
  TEXT_PLAIN = "text/plain",
  TEXT_RICHTEXT = "text/richtext",
  TEXT_RTF = "text/rtf",
  TEXT_SRT = "text/srt",
  TEXT_VTT = "text/vtt",
  TEXT_XML = "text/xml",
  TEXT_XSL = "text/xsl",
  TEXT_X_COMMA_SEPARATED_VALUES = "text/x-comma-separated-values",
  TEXT_X_LOG = "text/x-log",
  TEXT_X_PHP = "text/x-php",
  TEXT_X_VCARD = "text/x-vcard",
  VIDEO_3GP = "video/3gp",
  VIDEO_3GPP = "video/3gpp",
  VIDEO_3GPP2 = "video/3gpp2",
  VIDEO_AVI = "video/avi",
  VIDEO_MJ2 = "video/mj2",
  VIDEO_MP4 = "video/mp4",
  VIDEO_MPEG = "video/mpeg",
  VIDEO_MSVIDEO = "video/msvideo",
  VIDEO_OGG = "video/ogg",
  VIDEO_QUICKTIME = "video/quicktime",
  VIDEO_VND_RN_REALVIDEO = "video/vnd.rn-realvideo",
  VIDEO_WEBM = "video/webm",
  VIDEO_X_F4V = "video/x-f4v",
  VIDEO_X_FLV = "video/x-flv",
  VIDEO_X_MATROSKA = "video/x-matroska",
  VIDEO_X_MSVIDEO = "video/x-msvideo",
  VIDEO_X_MS_ASF = "video/x-ms-asf",
  VIDEO_X_MS_WMV = "video/x-ms-wmv",
  VIDEO_X_SGI_MOVIE = "video/x-sgi-movie"
}
